export default {
  floatRight: {
    float: 'right'
  },
  quizTable: {
    background: '#fff',
    padding: '10px',

    width: '100%',
    cellSpacing: '40px',
    top: '112px',
    textAlign: 'center',
    margin: '30px',
    marginTop: '60px'
  },
  quizTitle: {
    padding: '10px',
    background: '#fff',
    fontSize: '20px',
    top: '60px',
    color: '#576271',
    width: '100%',
    height: '70px',
    // fontWeight: "bold",
    margin: '30px'
  }
};
